var React = require('react');

function SubmenuArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.8338 0.90625L10.8351 1.87563L14.7876 5.71875L0.500488 5.71875L0.500488 7.09375L14.7876 7.09375L10.828 10.93L11.8338 11.9062L17.5005 6.40625L11.8338 0.90625Z","fill":"#494949"}));
}

SubmenuArrow.defaultProps = {"width":"18","height":"12","viewBox":"0 0 18 12","fill":"none"};

module.exports = SubmenuArrow;

SubmenuArrow.default = SubmenuArrow;
